import React, { PropsWithChildren } from 'react';
import { BottomNavbarSticky } from '@/components/Revamp/Navbar/BottomNavbarSticky/BottomNavbarSticky';
import { SideNavbar } from '@/components/Revamp/Navbar/SideNavbar';
import { toClassNames } from '@/utils';

interface BlankLayoutWithSidebarProps extends PropsWithChildren {
  backgroundColorClassname?: string;
}

const BlankLayoutWithSidebar: React.FC<BlankLayoutWithSidebarProps> = ({
  children,
  backgroundColorClassname = 'bg-revamp-cobalt-400',
}) => {
  return (
    <div className={toClassNames(['flex h-dvh w-dvw overflow-hidden', backgroundColorClassname])}>
      <SideNavbar className="hidden md:flex" />
      <div className={toClassNames('w-full overflow-auto', 'pb-bottom-navbar-mobile md:pb-0')}>{children}</div>
      <div className="fixed bottom-0 left-0 right-0 z-[100] md:hidden">
        <BottomNavbarSticky className="w-full" />
      </div>
    </div>
  );
};

export default BlankLayoutWithSidebar;
